module.exports = __webpack_public_path__ + "asset/image/unlock-8483.svg";